import { Form } from 'src/components/RcForm';

const useForms = () => {
  const [orderForm] = Form.useForm();
  const [pcForm] = Form.useForm();
  const [mobileForm] = Form.useForm();
  const [tabletForm] = Form.useForm();
  const [seoSettingForm] = Form.useForm();

  return { orderForm, pcForm, mobileForm, tabletForm, seoSettingForm };
};
export { useForms };
